import React from "react";
import { css } from "@emotion/css";
import { Card, Grid } from "semantic-ui-react";
import "../../styles/dashboard.scss";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";

const BCDashboard = ({ ...props }) => {
  const brokerTableHeaderOverrideCSS = css`
  border-top: ${(props.brokerColor && getIsWhiteLabeled()) ? props.brokerColor : "black"} 3px solid !important;
  padding: 10px 10px;
`;
  return (
    <Grid className="dashboard-grid">
      {props.DashboardLayout.map((row, i) => {
        return (
          <Grid.Row key={"dashboard-row-" + i} columns={props.isGreaterThanMobile ? row.length : 1} className={(props.DashboardLayout && (props.DashboardLayout.length - 1) === i && !props.isGreaterThanMobile) ? "dashboard-row-mobile-last" : "dashboard-row"}>
            {row.map((column, j) => {
              return (
                <Grid.Column 
                  key={"dashboard-column-" + j}
                  className={(j + 1 === row.length && !props.isGreaterThanMobile) ? "dashboard-column-margin" :
                    (j + 1 !== row.length && props.isGreaterThanMobile) ? "dashboard-column" :
                    (j !== 0 && !props.isGreaterThanMobile) ? "dashboard-column-margin" :
                    "dashboard-column-no-margin"} 
                  width={props.isGreaterThanMobile ? column.size : 16}
                >
                  {column.custom ? column.custom : <Card fluid className={`dashboard-card ${props.cardGrow && "dashboard-card-grow"}`}>
                    {!props.dashboardHeaderOptions && column.title ? <Card.Header className={props.customTitleClass ? props.customTitleClass :  "dashboard-card-title"}>
                      {column.title} 
                    </Card.Header> : column.title ?
                      <div>
                        <div className="dashboard-header-left-container">{column.title}</div>
                        <div className="dashboard-header-right-container">
                          {column.headerOptions && column.headerOptions.map((x, index) => {return <div className="dashboard-header-right-children" key={`dashboard-option-${index}`}>{x}</div>;})}
                        </div>
                      </div> : <React.Fragment/>
                    }
                    {column.meta && <Card.Meta className={"dashboard-card-meta"}>
                      {column.meta}
                    </Card.Meta>}
                    <Card.Content className={props.dashboardContentClass ? props.dashboardContentClass : (props.brokerColor && getIsWhiteLabeled()) ? brokerTableHeaderOverrideCSS : "dashboard-card-content"}>
                      <Card.Description className="dashboard-card-description">
                        {column.content && column.content}
                      </Card.Description>
                    </Card.Content>
                    {column.footer && <Card.Content extra className="dashboard-card-footer">
                      {column.footer}
                    </Card.Content>}
                  </Card>}
                </Grid.Column>
              );
            })}
          </Grid.Row>
        );
      })}
    </Grid>
  );
};

export default BCDashboard;